<template>
  <div>
    <v-layout row class="signup-wrapper">
      <v-flex xs12 md10 offset-md1 lg6 offset-lg3>
        <v-card> 
          <v-card-title class="headline primary darken-2 white--text" primary-title>
            Business Account Upgrade
          </v-card-title> 
          
          <v-card-text class="pa-4">
            <!-- Phone Field -->
            <div class="name-fields">
              <v-layout row>
                <v-flex xs2 sm1>
                  <i class="teal--text fas fa-phone fa-2x mt-2"></i>                            
                </v-flex>
                <v-flex xs10 sm10>
                <input 
                  @click="clearPhoneField()" 
                  id="phone" 
                  required 
                  type="tel" 
                  placeholder="Enter Phone Number" 
                  v-model="phone_number" 
                  ref="phone_number" 
                  name="phone" 
                  class="py-2 my-2" 
                  style="width: 100%!important; border-bottom: 1px grey solid" 
                />
                </v-flex>
                <v-flex xs1>
                  <v-btn @click.stop="$store.commit('activateDialog', true); phone_number_help = true; getSignUpFieldHelp()" 
                         flat fab small outline color="black" class="my-3" 
                         style="height:20px; width: 20px">
                    <i class="fas fa-question"></i>                            
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>

            <!-- Operator Selection -->
            <v-layout row wrap class="mb-4">
              <v-flex xs6 class="text-center pr-1">
                <v-card @click="selectOperator('MTN')"
                        :class="{ 'selected-operator': paymentMethod === 'MTN' }"
                        class="pa-2 operator-card">
                  <v-img :src="require('@/assets/mtn-mobile-money-logo.png')" 
                         contain height="60"></v-img>
                </v-card>
              </v-flex>
              
              <v-flex xs6 class="text-center pl-1">
                <v-card @click="selectOperator('OM')"
                        :class="{ 'selected-operator': paymentMethod === 'OM' }"
                        class="pa-2 operator-card">
                  <v-img :src="require('@/assets/om.png')" contain height="60"></v-img>
                </v-card>
              </v-flex>
            </v-layout>

            <!-- Payment Details -->
            <p class="mb-0">
              By clicking <b class="teal--text darken-2">Confirm</b>, a deposit transaction of 
              <b>10500 F CFA</b> will be triggered through 
              <b v-if="paymentMethod">{{ paymentMethod === 'MTN' ? 'MTN Mobile Money' : 'Orange Money' }}</b>
              <b v-else class="red--text">[ select payment method ]</b>
              from the phone number <b>{{ phone_number }}</b>
              <b v-if="!phone_number" class="red--text">[ phone number ]</b>
            </p>

            <!-- USSD Instructions -->
            <div v-if="paymentMethod" class="mt-3">
              <p class="mb-0">If facing difficulties, send manually using:</p>
              <p class="pl-2 mb-0 pt-1 red--text">
                - <b>{{ ussdCode }}</b>
                <v-btn icon @click="copyUSSD" class="ml-2" title="Copy USSD code">
                  <v-icon small>mdi-content-copy</v-icon>
                </v-btn>
              </p>
              <p class="pl-2 mb-0 pt-1" v-if="paymentMethod === 'MTN'">
                - Choose reference 1
              </p>
              <p class="pl-2 mb-0 pt-1" v-if="paymentMethod === 'OM'">
                - Input transaction amount
              </p>
              <p class="pl-2 mb-0 pt-1">
                - Always <b class="teal--text darken-2">Confirm</b> below
              </p>
            </div>
          </v-card-text>

          <!-- Dialog Actions -->
          <v-card-actions class="px-3"> 
            <v-btn color="teal" text @click="showPayment = false">Cancel</v-btn> 
            <v-spacer></v-spacer> 
            <v-btn color="teal darken-2" class="white--text" 
                   @click="handlePaymentConfirmation"
                   :disabled="!paymentMethod || !phone_number"
                   :loading="processingPayment">
              Confirm
            </v-btn>
          </v-card-actions>
        </v-card> 
      </v-flex>
    </v-layout>

    <!-- Newsletter Section -->
    <v-container class="elevation-12 white darken-2">
      <v-layout row>
        <v-flex xs12 md10 offset-md1>
          <v-slide-y-transition mode="out-in">
            <div style="z-index: 9999 !important">
              <h1>News</h1>
              <p>
                Get the latest updates, tips, and strategies for effective cash management.
              </p>
              <div class="text-xs-right ma-0 pa-0">
                <v-text-field name="email" label="Enter Your Email" id="email" outline></v-text-field>
                <v-btn class="white--text" round color="teal">
                  <span>Subscribe</span>
                </v-btn>
              </div>
            </div>
          </v-slide-y-transition>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      e1: true,
      helpDialogs: {
        fullnames: false,
        username: false,
        email: false,
        telephone: false,
        password: false,
        reference: false,
        phone_number: false
      },
      phone_number: "",

      showPayment: true,
      paymentMethod: '',
      transactionId: '',
      ussdCode: '',
      hrefTel: '',
    
      processingPayment: false,
      validationRules: {
        username: [
          v => !!v || 'Username required',
          v => (v && v.length >= 4) || 'Minimum 4 characters'
        ],
        password: [
          v => !!v || 'Password required',
          v => (v && v.length >= 8) || 'Minimum 8 characters'
        ],
        email: [
          v => !!v || 'Email required',
          v => /.+@.+\..+/.test(v) || 'Valid email required'
        ],
        phone: [
          v => !!v || 'Phone required',
          v => /^[0-9]{9}$/.test(v) || '9 digits required'
        ]
      }
    };
  },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    referralHint() {
      return this.$route.query.referral 
        ? 'Referral code from invitation'
        : 'Default referral code';
    }
  },

  mounted() {
    this.initializePhoneInput();
    this.$store.commit('setSaveItem', "");
    this.getUserInfo();
  },

  methods: {
initializePhoneInput() {
  const phoneInputField = this.$refs.phone_number;
  this.phoneInput = window.intlTelInput(phoneInputField, {
    initialCountry: "cm",
    preferredCountries: ["cm", "ng", "gh", "ke"],
    utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
  });

  // Sync intlTelInput value with Vue data
  phoneInputField.addEventListener('input', () => {
    this.phone_number = this.phoneInput.getNumber();
  });
  phoneInputField.addEventListener('countrychange', () => {
    this.phone_number = this.phoneInput.getNumber();
  });
},
    clearPhoneField() {
      if(this.phoneInput.getNumber() === "Enter Phone Number") {
        this.phone_number = "";
      }
    },



    selectOperator(operator) {
      this.paymentMethod = operator;
      this.generateUSSD();
      this.transactionId = this.generateTransactionId();
      this.showNotification(`${operator} selected`, "info");
    },

    generateTransactionId() {
      return `${this.paymentMethod}-${Date.now()}-${Math.floor(Math.random()*1000)}`;
    },

    generateUSSD() {
      const amount = 10500;
      if(this.paymentMethod === "MTN") {
        this.ussdCode = `*126*4*${this.$store.state.MerchantCodeMTN}*${amount}#`;
        this.hrefTel = `tel:*126*4*${this.$store.state.MerchantCodeMTN}*${amount}%23`;
      } else {
        this.ussdCode = `#150*47*${this.$store.state.MerchantCodeOrange}*${amount}#`;
        this.hrefTel = `tel:%23150*47*${this.$store.state.MerchantCodeOrange}*${amount}%23`;
      }
    },

async handlePaymentConfirmation() {
  if(!this.validatePayment()) return;

  try {
    this.processingPayment = true;
    this.generateUSSD();
    await this.initiatePayment();

  } catch (error) {

    if(error.notificationMessage) {
      this.showNotification(error.notificationMessage, "error");
    } else {
      this.showNotification(error.message || "Payment error", "error");
    }
  } finally {
    this.processingPayment = false;
  }
},

    validatePayment() {
      if(!this.paymentMethod) {
        this.showNotification("Select payment method", "error");
        return false;
      }
      if(!this.phoneInput?.isValidNumber()) {
        this.showNotification("Invalid phone number", "error");
        return false;
      }
      return true;
    },



    async initiatePayment() {
      const payload = {
        payment_method: this.paymentMethod,
        transaction_id: this.transactionId,
        transaction_phone: this.phoneInput.getNumber()
      };

      const config = this.$store.state.isAuthenticated 
        ? { headers: { Authorization: `Token ${this.$store.state.token}` } } 
        : {};

  try {
    const response = await axios.post('/api/v1/savings/business-account2/', payload, config);
    
    if(!response.data.success) {
      const error = new Error(response.data.error || 'Payment failed');
      
      error.notificationMessage = this.translateError(response.data.error);
     
      throw error;
      
    }

    this.showNotification(response.data.message, "success");
     this.handleRedirections();
    if(this.$store.state.isAuthenticated) await this.$store.dispatch('fetchUserData');
  } catch (error) {
    let message = 'Payment processing error';
    
    
    if(error.response) {
      const backendError = error.response.data;
      
    
      if(backendError.error === 'A business account request is already pending') {
        message = 'You already have a pending activation request. Please wait for confirmation.';
      }
    
      else if(typeof backendError === 'object') {
        message = Object.entries(backendError)
          .map(([field, errors]) => 
            `${field}: ${Array.isArray(errors) ? errors.join(', ') : errors}`
          )
          .join('\n');
      }
   
      else {
        message = backendError.error || backendError.detail || JSON.stringify(backendError);
      }
    }
    this.redirectToAll();
    const formattedError = new Error(message);
    formattedError.notificationMessage = message;
    throw formattedError;
  }
},
redirectToAll() {
  setTimeout(() => {
    if(this.$route.path !== '/All') {
      this.$router.push({ name: 'All' }).catch(() => {});
    }
    this.resetForm();
    this.showPayment = false;
  }, 1500); // Redirection plus rapide en cas d'erreur
},

translateError(errorKey) {
  const errorMessages = {
    'A business account request is already pending': 'You have a pending request already',
    'Invalid phone number': 'Please enter a valid phone number',
 
  };
  
  return errorMessages[errorKey] || errorKey;

},
    handleRedirections() {
    
      setTimeout(() => {
        if(this.isMobile) {
          window.location.href = this.hrefTel;
        } else {
          window.open(this.hrefTel, '_blank');
        }
      }, 500);

      // Redirect to dashboard
      setTimeout(() => {
        if(this.$route.path !== '/All') {
          this.$router.push({ name: 'All' }).catch(() => {});
        }
        this.resetForm();
        this.showPayment = false;
      }, 3000);
    },
    

    resetForm() {
      this.form = {
        name: '',
        username: '',
        telephone: '',
        email: '',
        affiliate_referral: '',
      };
      this.phone_number = '';
    },

    showNotification(message, type) {
      this.$store.commit('setSnackBarMessage', message);
      this.$store.commit('setSnackBarColor', type === "error" ? "red darken-4" : "teal darken-2");
      this.$store.commit('activateSnackBar', true);
    },

    copyUSSD() {
      navigator.clipboard.writeText(this.ussdCode);
      this.showNotification("USSD code copied", "success");
    },
    
    async getUserInfo() {
        this.$store.commit('setIsLoading', true)
        if (this.$store.state.isAuthenticated && !this.$store.state.user_info_state){
            await axios
                .get('/api/v1/home/get/user/info/')
                .then(response => {
                    this.user_credit = response.data[0]["user_credit"][0]["credit"]
                    this.$store.commit('setUser', response.data[0]["user"])
                    this.$store.commit('setUserState', response.data[0]["user_info"])
                    this.$store.commit('setUserInfo', response.data[0])
                    this.$store.commit('setUserName', response.data[0]["user"]["username"])

                    this.serial_no = this.$store.state.user_info.user_profile.serial_no
                })
                .catch(error => {
                    this.$store.commit('setSnackBarMessage', "An error occured, please check your internet connection and try again later.")
                    this.$store.commit('setSnackBarColor', "red darken-4")
                    this.$store.commit('activateSnackBar', true)
                })
        }
        this.$store.commit('setIsLoading', false)
    },

  }
};
</script>

<style scoped>
/* Maintain existing styles */
.selected-operator {
  border: 2px solid #009688 !important;
  background-color: #e0f2f1 !important;
}

.operator-card {
  cursor: pointer;
  transition: transform 0.3s ease;
}

.operator-card:hover {
  transform: scale(1.05);
}

.signup-wrapper {
  background: #f0f2f5;
  min-height: 100vh;
  padding: 72px 0 112px;
}

@media (max-width: 600px) {
  .v-dialog {
    margin: 0 !important;
    border-radius: 0 !important;
  }
  
  .v-card__title {
    font-size: 1.1rem !important;
    padding: 12px !important;
  }
  
  .operator-card {
    margin: 5px !important;
  }
}
</style>